import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-page-content wiki-page" }
const _hoisted_2 = { class: "d-flex flex-wrap" }
const _hoisted_3 = { class: "flex-grow-1" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WikiBreadCrumbs = _resolveComponent("WikiBreadCrumbs")!
  const _component_WikiRoleGuide = _resolveComponent("WikiRoleGuide")!
  const _component_TopRolePlayer = _resolveComponent("TopRolePlayer")!
  const _component_WikiPlayCta = _resolveComponent("WikiPlayCta")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_WikiBreadCrumbs),
    _createElementVNode("h1", null, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "good-loyalty-icon" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('lovers.seoHeading')), 1)
    ]),
    _createVNode(_component_WikiRoleGuide, { role: "lovers" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TopRolePlayer, {
          role: "tristan",
          displayRole: true,
          class: "my-4"
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_TopRolePlayer, {
          role: "isolde",
          displayRole: true,
          class: "my-4"
        })
      ])
    ]),
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t('lovers.generalTips')), 1),
    _createElementVNode("ul", null, [
      _createElementVNode("li", {
        innerHTML: _ctx.$t('lovers.maintainIndividualPersonas')
      }, null, 8, _hoisted_5),
      _createElementVNode("li", {
        innerHTML: _ctx.$t('lovers.protectEachOther')
      }, null, 8, _hoisted_6),
      _createElementVNode("li", {
        innerHTML: _ctx.$t('lovers.disguiseYourGameplay')
      }, null, 8, _hoisted_7)
    ]),
    _createVNode(_component_WikiPlayCta)
  ]))
}